<div *ngIf="chartReady; else loading" class="charts-grid">
    <div *ngFor="let chart of chartDefinitions" class="chart-item">
        <google-chart [type]="chart.chartType" [columns]="chart.chartColumns" [data]="chart.chartData"
            [options]="chart.chartOptions" [width]="1000" [height]="400">
        </google-chart>

    </div>
</div>

<ng-template #loading>
    <div>Loading chart metadata and data...</div>
</ng-template>